import { NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';

@NgModule({
  imports: [LxlibUtilModule],
})
export class LodopModule {}
